import { VIEWER_MODES } from 'constants/all';

import {
  disabled,
  enabled,
  type ActionAvailability,
} from 'modules/common/entityActions';

import { type ViewerAccess } from './hostContracts/access';
import { type EditLock, type ViewerEditLocks } from './hostContracts/editLocks';

export const SHARED_PART_EDIT_REASON = 'Cannot edit a shared part.';
export const PART_EDIT_LOADING_REASON = 'Loading part editability…';

const lockReason = (lock: EditLock): string | undefined => {
  switch (lock.status) {
    case 'loading':
      return PART_EDIT_LOADING_REASON;
    case 'locked':
      return lock.reason;
    default:
      return undefined;
  }
};

/**
 * Whether the part's own data may be changed (print units, descriptors,
 * geometric findings). Early returns set the reason priority.
 */
export const getPartEditAvailability = (
  access: ViewerAccess,
  locks: Pick<ViewerEditLocks, 'partLock' | 'collaborationLock'>,
): ActionAvailability => {
  if (access.relationship === VIEWER_MODES.SHARE) {
    return disabled(SHARED_PART_EDIT_REASON);
  }
  // Loading is a reason, never none: the DXF mapping lock reads only the reason,
  // and a missing one unlocks.
  const reason =
    lockReason(locks.partLock) ?? lockReason(locks.collaborationLock);
  return reason ? disabled(reason) : enabled();
};
